/* Tidal — buy box + nav */
(function () {
  'use strict';

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.getElementById('SiteNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- buy box ---------- */
  function initBuyBox(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form        = root.querySelector('form.tidal-atc-form') || root.querySelector('form[action*="/cart/add"]');
    var idInput     = root.querySelector('[data-variant-id]');
    var atc         = root.querySelector('[data-atc]');
    var priceNow    = root.querySelector('[data-price-now]');
    var priceWas    = root.querySelector('[data-price-was]');
    var priceSave   = root.querySelector('[data-price-save]');
    var colorLabel  = root.querySelector('[data-color-label]');
    var mainImg     = root.querySelector('[data-gallery-main] img');
    var track       = root.querySelector('[data-gallery-track]');
    var stickyBar   = root.querySelector('[data-stickybar]');
    var stickyBtn   = root.querySelector('[data-sticky-atc]');
    var stickyNow   = root.querySelector('[data-sticky-now]');
    var stickyWas   = root.querySelector('[data-sticky-was]');
    var stickyImg   = root.querySelector('[data-sticky-img]');

    var state = {
      color: root.querySelector('[data-color][aria-pressed="true"]'),
      pack:  root.querySelector('[data-pack][aria-pressed="true"]')
    };
    state.color = state.color ? state.color.dataset.color : null;
    state.pack  = state.pack  ? state.pack.dataset.pack  : null;

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
    }

    function find() {
      return variants.filter(function (v) {
        return v.color === state.color && v.pack === state.pack;
      })[0];
    }

    function press(nodes, attr, value) {
      nodes.forEach(function (n) {
        n.setAttribute('aria-pressed', n.dataset[attr] === value ? 'true' : 'false');
      });
    }

    /* Not every colour exists at every pack size — "Black + White" is a 2-pack
       only. Hide the ones with no variant, and snap off a colour that just
       became invalid so the form can never point at a variant that isn't real. */
    function colorOkFor(color, pack) {
      return variants.some(function (v) { return v.color === color && v.pack === pack; });
    }

    function syncColors() {
      var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-color]'));
      swatches.forEach(function (s) {
        s.hidden = !colorOkFor(s.dataset.color, state.pack);
      });
      if (!colorOkFor(state.color, state.pack)) {
        var firstOk = swatches.filter(function (s) { return !s.hidden; })[0];
        if (firstOk) state.color = firstOk.dataset.color;
      }
    }

    function render() {
      syncColors();
      var v = find();

      press(Array.prototype.slice.call(root.querySelectorAll('[data-color]')), 'color', state.color);
      press(Array.prototype.slice.call(root.querySelectorAll('[data-pack]')), 'pack', state.pack);

      if (colorLabel) colorLabel.textContent = state.color || '';

      /* scroll the carousel to the image for the selected colour */
      if (track) {
        var swap = root.querySelector('[data-color="' + state.color + '"]');
        if (swap && swap.dataset.image) {
          var slides = slideList();
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].dataset.image === swap.dataset.image) { showIndex(i); break; }
          }
        }
      }

      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;

      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }

      if (priceNow) priceNow.textContent = money(v.price);

      if (priceWas) {
        if (v.compare && v.compare > v.price) {
          priceWas.textContent = money(v.compare);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }

      if (priceSave) {
        if (v.compare && v.compare > v.price) {
          priceSave.textContent = 'Save ' + Math.round((1 - v.price / v.compare) * 100) + '%';
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }

      /* the sticky bar shows the same variant as the buy box, always */
      if (stickyNow) stickyNow.textContent = money(v.price);
      if (stickyWas) {
        if (v.compare && v.compare > v.price) {
          stickyWas.textContent = money(v.compare);
          stickyWas.hidden = false;
        } else {
          stickyWas.hidden = true;
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        stickyBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      if (stickyImg) {
        var shown = slideList()[currentIndex()];
        if (shown && shown.dataset.image) stickyImg.src = shown.dataset.image;
      }
    }

    /* The thumb strip stays in the DOM even when hidden on mobile — it is the
       ordered list the arrows page through. */
    /* the thumb strip scrolls, so paging with the arrows has to bring the newly
       active thumb back into view or it silently selects something off-screen */
    function centerActiveThumb() {
      var el = root.querySelector('[data-gallery-thumb][aria-current="true"]');
      if (!el) return;
      var strip = el.parentNode;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      strip.scrollLeft = Math.max(0, el.offsetLeft - (strip.clientWidth - el.offsetWidth) / 2);
    }

    function thumbList() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    }

    function slideList() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    }

    /* thumbs mirror the carousel; they never drive the image directly */
    function markActive(i) {
      var thumbs = thumbList();
      for (var n = 0; n < thumbs.length; n++) {
        thumbs[n].setAttribute('aria-current', n === i ? 'true' : 'false');
      }
      centerActiveThumb();
      if (stickyImg) {
        var s = slideList()[i];
        if (s && s.dataset.image) stickyImg.src = s.dataset.image;
      }
    }

    function showIndex(i) {
      var slides = slideList();
      if (!slides.length || !track) return;
      /* clamp rather than wrap — a scroll track has real ends, and wrapping
         would fight the user's own momentum scroll */
      if (i < 0) i = 0;
      if (i >= slides.length) i = slides.length - 1;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      markActive(i);
    }

    /* derived from scroll position, so swiping and clicking agree */
    function currentIndex() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    if (track) {
      var scrollTick;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTick);
        scrollTick = setTimeout(function () { markActive(currentIndex()); }, 90);
      }, { passive: true });
      window.addEventListener('resize', function () { markActive(currentIndex()); }, { passive: true });
    }

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-color]');
      if (c) { state.color = c.dataset.color; render(); return; }
      var p = e.target.closest('[data-pack]');
      if (p) { state.pack = p.dataset.pack; render(); return; }
      var th = e.target.closest('[data-gallery-thumb]');
      if (th) { showIndex(thumbList().indexOf(th)); }
    });

    /* ajax add to cart with graceful fallback to a normal form post */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var v = find();
        if (!v) return;
        atc.disabled = true;
        var was = atc.textContent;
        atc.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            /* straight to the cart page — leave the button disabled and reading
               "Adding…" so the navigation can't be double-fired */
            window.location.href = '/cart';
          })
          .catch(function () {
            atc.disabled = false;
            atc.textContent = was;
            form.submit();   /* native post also lands on /cart */
          });
      });
    }

    /* Sticky buy bar: reveal once the real Add to Cart has scrolled off the top.

       Deliberately a scroll check rather than an IntersectionObserver. An
       observer only fires when the intersection state CHANGES, and jumping
       straight past the buy box — an anchor link, a restored scroll position,
       a fast flick — goes from "not intersecting, below" to "not intersecting,
       above" without ever entering view. Same state both times, no callback,
       bar never appears. The rect read is throttled to one per frame. */
    if (stickyBar && atc && stickyBtn) {
      var atcBlock = atc.closest('.atc-block') || atc;

      /* Evaluated straight from the scroll event rather than through a
         requestAnimationFrame queue. Browsers already coalesce scroll to at most
         one event per frame, so this is a single rect read per frame — and it
         removes a dependency on rAF actually being serviced. */
      var evaluate = function () {
        var past = atcBlock.getBoundingClientRect().bottom < 0;
        if (stickyBar.hidden === !past) return;
        stickyBar.hidden = !past;
        if (past) {
          /* force a reflow between unhiding and adding the class, or the browser
             batches both and the slide-up transition never runs — leaving the bar
             unhidden but still translated off-screen */
          void stickyBar.offsetWidth;
          stickyBar.classList.add('is-in');
        } else {
          stickyBar.classList.remove('is-in');
        }
      };

      window.addEventListener('scroll', evaluate, { passive: true });
      window.addEventListener('resize', evaluate, { passive: true });
      evaluate();

      stickyBtn.addEventListener('click', function () {
        if (!atc.disabled) atc.click();
      });
    }

    render();
  }

  function toast() {
    var el = document.getElementById('TidalCartToast');
    if (!el) return;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 4000);
  }

  function bumpCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var nodes = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < nodes.length; i++) nodes[i].textContent = '(' + c.item_count + ')';
      })
      .catch(function () {});
  }

  /* ---------- scroll-snap carousel (mobile) ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev  = root.querySelector('[data-carousel-prev]');
    var next  = root.querySelector('[data-carousel-next]');
    var dots  = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    /* offsetLeft is relative to the offset parent, not the track — subtract the
       first slide's so these are true scroll positions. */
    function slideOffset(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }

    function current() {
      /* nearest slide to the track's left edge — survives partial swipes */
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slideOffset(i) - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: slideOffset(i), behavior: 'smooth' });
    }

    function sync() {
      var i = current();
      for (var n = 0; n < dots.length; n++) {
        dots[n].setAttribute('aria-current', n === i ? 'true' : 'false');
      }
    }

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });
    sync();
  }

  /* Autoplay the silent demo clips only while they are on screen. The markup
     already carries autoplay+muted+preload="none", so this is a nudge for
     browsers that will not start an offscreen video on their own, plus a
     pause when it scrolls away. */
  function initAutoVideo(v) {
    if (v.dataset.autovidBound) return;
    v.dataset.autovidBound = '1';
    v.muted = true;                 // belt and braces: iOS needs this set in JS too
    if (!('IntersectionObserver' in window)) { v.play().catch(function () {}); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) v.play().catch(function () {});
        else v.pause();
      }
    }, { threshold: 0.25 });
    io.observe(v);
  }

  /* Review / customer clips: the play button is the only chrome. No native
     controls, so no scrubber, mute, fullscreen, overflow menu or duration.
     Click the video to pause; when it reaches the end it stops and resets. */
  function initUgcVideo(tile) {
    if (tile.dataset.ugcBound) return;
    tile.dataset.ugcBound = '1';
    var v = tile.querySelector('[data-ugc-video]');
    var btn = tile.querySelector('[data-ugc-play]');
    if (!v || !btn) return;

    v.controls = false;

    function showBtn() { btn.hidden = false; }
    function hideBtn() { btn.hidden = true; }

    function stopOthers() {
      var all = document.querySelectorAll('[data-ugc-video]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] === v) continue;
        all[i].pause();
        var b = all[i].parentNode.querySelector('[data-ugc-play]');
        if (b) b.hidden = false;
      }
    }

    function start() {
      stopOthers();
      hideBtn();
      v.play().catch(showBtn);
    }

    btn.addEventListener('click', start);

    // tapping the frame itself pauses/resumes — the only other affordance
    v.addEventListener('click', function () {
      if (v.paused) { start(); } else { v.pause(); }
    });

    v.addEventListener('pause', showBtn);
    v.addEventListener('play', hideBtn);
    v.addEventListener('ended', function () {
      // played all the way through: stop, don't loop, go back to the poster
      v.pause();
      showBtn();
      v.load();
    });
  }

  function boot() {
    var boxes = document.querySelectorAll('[data-buybox]');
    for (var i = 0; i < boxes.length; i++) initBuyBox(boxes[i]);
    var cars = document.querySelectorAll('[data-carousel]');
    for (var c = 0; c < cars.length; c++) initCarousel(cars[c]);
    var vids = document.querySelectorAll('[data-autovid]');
    for (var v = 0; v < vids.length; v++) initAutoVideo(vids[v]);
    var tiles = document.querySelectorAll('.ugc__tile, .prev__card, .xform__card');
    for (var t = 0; t < tiles.length; t++) initUgcVideo(tiles[t]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
